export class TechVendorOrganization {
    address: string;
    city: string;
    state: string;
    zipcode: string;
    countryId: string;
    addressType: string;
    userId: string;
}
export class TechVendorOrganizationModal {
  organizationId: string;
  countryId: string;
  industryId: string;
  jobTitleId: string;
  lineOfBusinessId: string;
  employeeSizeId: string;
  revenueId: string;
  itBudgetId: string;
  labelName: string;
  regionsCovered: any; 
}
  



// WEBPACK FOOTER //
// ./src/app/feature/main/tech-vendor/shared/models/tech-vendor-organization-model.ts